import { RichText } from "@/components/richText/richText.component";

import { CONTENT_MODAL_QUERY_PARAM } from "@/constants/contentModal.constants";
import type { RichText as RichTextType } from "@/sanity.types";

export const PromotionLegalModal = ({
  legalCallout,
}: PromotionLegalModalProps) => {
  if (!hasDocumentAction(legalCallout)) return null;

  return (
    <RichText
      data-testid="promotion-legal-callout"
      interactiveQueryParam={CONTENT_MODAL_QUERY_PARAM}>
      {legalCallout}
    </RichText>
  );
};

const hasDocumentAction = (content?: RichTextType | null) =>
  content?.some(
    (block) =>
      block._type === "block" &&
      block.markDefs?.some((mark) => mark._type === "documentAction"),
  ) ?? false;

export type PromotionLegalModalProps = {
  legalCallout?: RichTextType | null;
};
